export default __webpack_public_path__ + "static/media/icon_respaldo.58c53aa5.png";